"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Introspection = void 0;
var SkillBuildJob_1 = require("./SkillBuildJob");
var Introspection = /** @class */ (function (_super) {
    __extends(Introspection, _super);
    function Introspection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Introspection";
        /**
         * Introspects the build jobs currently available in the system
         */
        _this.buildJobs = function (tenantId, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var entity = new SkillBuildJob_1.SkillBuildJob();
            config(entity);
            return "buildJobs(tenantId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Introspection;
}(Array));
exports.Introspection = Introspection;
//# sourceMappingURL=Introspection.js.map